<template>
	<div class="oow-container">		
        <!-- 搜索区域 -->
        <div class="search-section">
            <van-search 
                v-model="value" 
                placeholder="请输入搜索关键词，例如上门" 
                @search="search"
                show-action
                class="search-box"
            >
                <template #action>
                    <div @click="search" class="search-action">搜索</div>
                </template>
            </van-search>
        </div>

        <!-- 结果统计 -->
        <div class="result-section">
            <div class="result-count">
                <van-icon name="search" class="count-icon" />
                共有 {{rows}} 个延保产品
            </div>
        </div>

        <!-- 产品列表 -->
        <div class="product-list">
            <div 
                class="product-card" 
                v-for="item in productList" 
                :key="item.ProductCode"
                @click="selectItem(item.ProductCode)"
            >
                <div class="product-image">
                    <van-image
                        width="80"
                        height="80"
                        :src="item.ImageURL"
                        fit="cover"
                        radius="8"
                    />
                </div>
                <div class="product-info">
                    <h3 class="product-title">{{ item.ProductName }}</h3>
                    <p class="product-code">{{ item.ProductCode }}</p>
                    <div class="product-price">
                        <span class="price-label">价格：</span>
                        <span class="price-value">¥{{ item.UserPrice }}</span>
                    </div>
                </div>
                <van-icon name="arrow" class="arrow-icon" />
            </div>
        </div>

        <!-- 空状态 -->
        <div v-if="productList.length === 0" class="empty-state">
            <van-empty description="未找到相关延保产品" image="search">
                <van-button 
                    round 
                    type="primary" 
                    class="retry-btn"
                    @click="value = ''; search();"
                >
                    显示全部
                </van-button>
            </van-empty>
        </div>
	</div>
</template>

<script>
	import Vue from 'vue'
	export default {
	  name: 'NEWSR', 
	  data(){
	  	return{	
            feedback: require("@/assets/icon/oow.png"),
            productList:[],
            productList2:[],
            value:'',
            rows:'0'
        }				
	  },
	  created(){
		this.getData();
	  },
	  mounted(){	
        document.title ='服务产品列表';
      },
	  methods:{
		getData(){
			var that = this
			Vue.axios.get('https://t3.lenovoimage.com/api/web2/getProductsbyCID?CategoryID=27')
			   .then( function (response) {						  
				   that.productList = response.data.Data;
				   that.productList2 = response.data.Data;
				   that.rows = that.productList.length;
			   })			   
			   .catch(function (error) {
			    console.log(error);
			   }) 	
		},
		selectItem(e){
			console.log(e)
			this.$root.common.curorderid = e
			this.$router.push({ path:'/oow/info'  })
		},
		search() {
		   if (this.value.length > 0) {
               var result = this.productList2.filter(item => {
                   if (item.ProductName.includes(this.value)) {
                       return item
                   }
               })	
               console.log(result)
               this.productList = result;
		   } else {
			   this.productList = this.productList2;
		   }
		   this.rows = this.productList.length;
		}
	  }
	}
</script>

<style scoped>
.oow-container {
    background-color: #f7f8fa;
    min-height: 100vh;
    padding-bottom: 20px;
}

.search-section {
    background-color: #ffffff;
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
}

.search-box {
    padding: 0;
    border-radius: 8px;
    overflow: hidden;
}

.search-action {
    color: #1989fa;
    font-size: 14px;
    padding: 0 8px;
}

.result-section {
    padding: 16px;
}

.result-count {
    background-color: #e6f7ff;
    border: 1px solid #91d5ff;
    border-radius: 6px;
    padding: 12px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
}

.count-icon {
    margin-right: 8px;
    font-size: 16px;
}

.product-list {
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.product-card {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    gap: 12px;
    transition: all 0.3s ease;
    cursor: pointer;
}

.product-card:active {
    background-color: #f5f5f5;
    transform: scale(0.98);
}

.product-image {
    flex-shrink: 0;
}

.product-info {
    flex: 1;
    min-width: 0;
}

.product-title {
    font-size: 15px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 6px;
    line-height: 1.4;
    word-break: break-all;
}

.product-code {
    font-size: 13px;
    color: #969799;
    margin-bottom: 8px;
}

.product-price {
    display: flex;
    align-items: center;
}

.price-label {
    font-size: 13px;
    color: #646566;
}

.price-value {
    font-size: 16px;
    font-weight: bold;
    color: #ee0a24;
}

.arrow-icon {
    color: #969799;
    font-size: 14px;
    flex-shrink: 0;
}

.empty-state {
    padding: 40px 20px;
}

.retry-btn {
    margin-top: 16px;
}
</style>